export const createHoverProps = (callback, options = { delay: 333, focusElem: true }) => {
    let delayTimeout;
    return {
        onMouseEnter: (e) => {
            clearTimeout(delayTimeout);
            delayTimeout = window.setTimeout(() => {
                options.focusElem && e.target.focus();
                callback && callback();
            }, options.delay || 333);
        },
        onMouseLeave: () => {
            clearTimeout(delayTimeout);
        },
    };
};
